"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFieldByBasicType = exports.getFieldEditorType = exports.EditorType = void 0;
const core_1 = require("@apitable/core");
var EditorType;
(function (EditorType) {
    EditorType[EditorType["None"] = 0] = "None";
    EditorType[EditorType["Text"] = 1] = "Text";
    EditorType[EditorType["Number"] = 2] = "Number";
    EditorType[EditorType["Rating"] = 3] = "Rating";
    EditorType[EditorType["Boolean"] = 4] = "Boolean";
    EditorType[EditorType["DateTime"] = 5] = "DateTime";
    EditorType[EditorType["Options"] = 6] = "Options";
    EditorType[EditorType["Member"] = 7] = "Member";
    EditorType[EditorType["Currency"] = 8] = "Currency";
    EditorType[EditorType["Percent"] = 9] = "Percent";
})(EditorType = exports.EditorType || (exports.EditorType = {}));
const editorMap = {
    [core_1.FieldType.Attachment]: EditorType.None,
    [core_1.FieldType.DateTime]: EditorType.DateTime,
    [core_1.FieldType.CreatedTime]: EditorType.DateTime,
    [core_1.FieldType.LastModifiedTime]: EditorType.DateTime,
    [core_1.FieldType.MultiSelect]: EditorType.Options,
    [core_1.FieldType.SingleSelect]: EditorType.Options,
    [core_1.FieldType.Number]: EditorType.Number,
    [core_1.FieldType.AutoNumber]: EditorType.Number,
    [core_1.FieldType.Currency]: EditorType.Currency,
    [core_1.FieldType.Percent]: EditorType.Percent,
    [core_1.FieldType.Rating]: EditorType.Rating,
    [core_1.FieldType.Text]: EditorType.Text,
    [core_1.FieldType.URL]: EditorType.Text,
    [core_1.FieldType.Email]: EditorType.Text,
    [core_1.FieldType.Phone]: EditorType.Text,
    [core_1.FieldType.Link]: EditorType.Text,
    [core_1.FieldType.Checkbox]: EditorType.Boolean,
    [core_1.FieldType.Member]: EditorType.Member,
    [core_1.FieldType.CreatedBy]: EditorType.Member,
    [core_1.FieldType.LastModifiedBy]: EditorType.Member,
    [core_1.FieldType.SingleText]: EditorType.Text,
    [core_1.FieldType.Cascader]: EditorType.Text,
};
const getFieldEditorType = (field) => {
    var _a, _b;
    const { basicValueType, valueType, isComputed } = core_1.Field.bindModel(field);
    if (isComputed) {
        if (field.type === core_1.FieldType.LookUp) {
            const expr = core_1.Field.bindModel(field).getExpression();
            if (expr) {
                switch (basicValueType) {
                    case core_1.BasicValueType.Number:
                        return EditorType.Number;
                    case core_1.BasicValueType.DateTime:
                        return EditorType.DateTime;
                    case core_1.BasicValueType.Boolean:
                        return EditorType.Boolean;
                    default:
                        return EditorType.Text;
                }
            }
            const entityField = core_1.Field.bindModel(field).getLookUpEntityField();
            if (entityField) {
                // lookup out of the rating field, using the numeric editor.
                if (entityField.type === core_1.FieldType.Rating)
                    return EditorType.Number;
                return editorMap[field.type] || (0, exports.getFieldEditorType)(entityField);
            }
            return EditorType.None;
        }
        if (field.type === core_1.FieldType.Formula) {
            switch (valueType) {
                case core_1.BasicValueType.Number: {
                    const formatType = (_b = (_a = field.property) === null || _a === void 0 ? void 0 : _a.formatting) === null || _b === void 0 ? void 0 : _b.formatType;
                    if (formatType === core_1.FieldType.Currency) {
                        return EditorType.Currency;
                    }
                    else if (formatType === core_1.FieldType.Percent) {
                        return EditorType.Percent;
                    }
                    return EditorType.Number;
                }
                case core_1.BasicValueType.DateTime:
                    return EditorType.DateTime;
                case core_1.BasicValueType.Boolean:
                    return EditorType.Boolean;
                default:
                    return EditorType.Text;
            }
        }
    }
    return editorMap[field.type];
};
exports.getFieldEditorType = getFieldEditorType;
const getFieldByBasicType = (field) => {
    const { valueType } = core_1.Field.bindModel(field);
    switch (valueType) {
        case core_1.BasicValueType.Number:
            return {
                id: 'fidxxxxxxxxx',
                name: 'fakename',
                type: core_1.FieldType.Number,
                property: field.property.formatting || core_1.NumberField.defaultProperty(),
            };
        case core_1.BasicValueType.DateTime:
            return {
                id: 'fidxxxxxxxxx',
                name: 'fakename',
                type: core_1.FieldType.DateTime,
                property: field.property.formatting || core_1.DateTimeField.defaultProperty(),
            };
        default:
            return;
    }
};
exports.getFieldByBasicType = getFieldByBasicType;
